

















































































































































import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import AbpBase from "@/lib/abpbase";
import SwitchTimingPO from "@/store/entities/devices/switchs/switchtimingpo";
import TreeSelect from "@riophae/vue-treeselect";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
import { Common } from "@/lib/Common/Guid";
@Component({
  components: { TreeSelect },
})
export default class TimingSetting extends AbpBase {
  @Prop({ type: Boolean, default: false }) value: boolean;
  @Prop({ type: Array, default: [] }) switchId: any[];
  @Prop({ type: Array, default: [] }) switchNo: any[];
  timingpo: SwitchTimingPO = new SwitchTimingPO();
  loading: boolean = false;
  isupdate: boolean = false; //是否更新
  async created() { }
  //保存
  save() {
    (this.$refs.meterModelForm as any).validate(async (valid: boolean) => {
      if (valid) {
        this.loading = true;
        await this.$store
          .dispatch({
            type: "switchtiming/update",
            data: this.timingpo,
          })
          .catch(() => {
            this.loading = false;
          });
        this.loading = false;
        (this.$refs.meterModelForm as any).resetFields();
        this.$emit("save-success");
        this.$emit("input", false);
      }
    });
  }
  cancel() {
    (this.$refs.meterModelForm as any).resetFields();
    this.$emit("input", false);
  }
  async visibleChange(value: boolean) {
    if (!value) {
      this.$emit("input", value);
    } else {
      let res = await this.$store
        .dispatch({
          type: "switchtiming/get",
          id: this.switchId[0],
        })
        .catch(() => {
          this.loading = false;
        });
      if (res == null) {
      } else {
        this.timingpo = res;
        if (this.switchNo.length > 0) {
          this.timingpo.switchNo = "";
          this.switchNo.forEach((ele) => {
            if (this.timingpo.switchNo.length == 0) {
              this.timingpo.switchNo = ele;
            } else {
              this.timingpo.switchNo = this.timingpo.switchNo + ";" + ele;
            }
          });
          this.timingpo.switchsId = this.switchId;
        }
      }
    }
  }
  modelRule = {
    switchNo: [
      {
        trigger: "blur",
      },
    ],
  };
  //区域
  async areaTree() {
    await this.$store
      .dispatch("area/getAreaSelectTree")
      .then((val) => {
        this.$data.arealist = val;
      })
      .catch((err) => {
        console.log(err);
      });
  }
  //获取模型
  async getModelList() {
    this.$data.modelList = [];
    await this.$store
      .dispatch("switchmodel/getalllist")
      .then((val) => {
        if (val.length > 0) {
          val.forEach((ele) => {
            this.$data.modelList.push({ label: ele.name, value: ele.id });
          });
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }
  data() {
    return {
      arealist: [],
      transferType: [],
      ispType: [],
      potocolType: [],
      modelList: [],
      deviceType: [],
      organizations: [],
      normalizer(node) {
        if (node.children && !node.children.length) {
          delete node.children;
        }
        return {
          id: node.id,
          label: node.label,
          children: node.children,
        };
      },
    };
  }
  @Watch("switchId", { deep: true })
  @Watch("switchNo", { deep: true })
  getitemId() {
    this.timingpo.switchsId = this.switchId;
  }
}
